// The picture that stands for an issue in a list, a board card or a picker.
//
// Best preview first: the generated thumbnail (utils/issueThumbnail.js keeps
// it current with the newest media of ANY kind - image, video frame, PDF page
// one), then the 3D viewer snapshot markup saves refresh, then the first
// resolution screenshot, then the first image somebody attached. Paths the
// server hands back are relative to the API origin, absolute ones (R2) are
// used as they are.
import { url } from "api";

export const issuePreviewSrc = (item) => {
  const pick = item?.thumbnail
    || item?.sourceModelViewer?.screenshot
    || item?.firstElementShot
    || item?.firstAttachmentImage
    || (item?.attachments || []).find((a) => a && a.kind === "image" && a.url)?.url
    || "";
  if (!pick) return "";
  return pick.startsWith("/") ? `${url}${pick}` : pick;
};

export default issuePreviewSrc;
